import React, { Component } from 'react';
import { Gallery } from '$components/projects';
import { connect } from 'react-redux';
import { showNotification, changeTitle } from '$actions/root';
import { getGallery, getProjectGallery, getSubmission, createGalleryReport, getProjects, getProject } from '../../api';
import { browserHistory } from 'react-router';
import {Translate} from "$common";

@connect(null, { showNotification, changeTitle })
export default class GalleryRoute extends Component {
  state = {
    page: 1,
    filters: [],
    gallery: [],
    isFetching: true,
    keepPreviousData: false
  };

  loadData() {
    const { id } = this.props.params;
    if (id) {
      this.loadProjectGallery(id);
    } else {
      this.loadGallery();
    }
  }

  async loadGallery(props){
    this.setState({ isFetching: true });

    const { keepPreviousData } = this.state;
    const { query } = (props || this.props).location;
    if (keepPreviousData) {
      query.page = this.state.page;
    }
    const { data: gallery, meta: { total_count: totalCount } } = await getGallery(query);

    this.setState({
      gallery: keepPreviousData ? [ ...this.state.gallery, ...gallery ] : gallery,
      totalCount,
      page: keepPreviousData ? this.state.page : query.page,
      isFetching: false,
      keepPreviousData: false,
      projectId: null
    });
  }

  // Load specific project gallery
  async loadProjectGallery(project_id) {
    this.setState({ isFetching: true });

    const { keepPreviousData } = this.state;
    const { query } = this.props.location;

    browserHistory.push({
      pathname: `/gallery/${project_id}`,
      query: query
    });

    if (keepPreviousData) {
      query.page = this.state.page;
    }
    const { data: gallery, meta: { total_count: totalCount } } = await getProjectGallery(project_id, query);

    if (keepPreviousData) {
      this.state.gallery.media.items = [ ...this.state.gallery.media.items, ...gallery.media.items ];
    }

    this.setState({
      gallery: keepPreviousData ? this.state.gallery : gallery,
      totalCount,
      page: keepPreviousData ? this.state.page : query.page,
      isFetching: false,
      projectId: project_id,
      keepPreviousData: false
    });
  }

  componentWillMount() {
    this.props.changeTitle(Translate.get('gallery'))
    this.loadData();
  }

  updateFilter(key, value) {
    const filterTimeoutInterval = 100;

    setTimeout(() => {
      const query = { ...this.props.location.query };
      const { id } = this.props.params;

      query[key] = value;

      browserHistory.push({
        pathname: id ? `/gallery/${id}` : '/gallery',
        query: query
      });

      this.loadData();
    }, filterTimeoutInterval);
  }

  loadMore(nextPage) {
    this.setState({ keepPreviousData: true, page: nextPage });
    const loadMoreTimeoutInterval = 200;

    setTimeout(() => {
      this.loadData();
    }, loadMoreTimeoutInterval)
  }

  async createReport(data, success_message) {
    await createGalleryReport(data);
    this.props.showNotification(success_message, 'success');
  }

  render() {
    const { gallery, totalCount, page, isFetching, projectId, keepPreviousData } = this.state;

    return(
      <Gallery
        gallery={gallery}
        loadGallery={::this.loadGallery}
        loadProjectGallery={::this.loadProjectGallery}
        loadMore={::this.loadMore}
        onFilterChange={::this.updateFilter}
        totalCount={totalCount}
        currentPage={page || 1}
        isFetching={isFetching}
        keepPreviousData={keepPreviousData}
        projectId={projectId}
        getProjects={getProjects}
        getProject={getProject}
        createGalleryReport={::this.createReport}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/projects/gallery.js